import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronUp, FaInstagram, FaFacebookF, FaUsers } from "react-icons/fa";
import { useLanguage } from "../pages/LanguageContext";
import Alfurjan from "../images/Alfurjan.png";
import Zaaabeel from "../images/zaaabeel.jpg";
import PlanB from "../images/planB.jpg";
import Hills from "../images/Gemini_Generated_Image_n02nhgn02nhgn02n.png";
import Albeer from "../images/albeer.jpg";
import { FaMapMarkerAlt } from "react-icons/fa";
import Tokyo from "../images/Tokyo.png";
import Blind from "../images/Blind.jpg";
import Damac from "../images/Damac.jpg";
import Rami from "../images/rami.jpg";
import lorans from "../images/lorans.jpeg";
import Sabbag from "../images/Mohammad-Alsabbagh.jpg";
import leen from "../images/leen.jpeg";
import hamza from "../images/hmas.jpeg";
import MD from "../images/MD.jpg";
import Omar from "../images/Omar.jpg";
import couple from "../images/happy.jpg";
import om from "../images/om.jpg";
import Alshafi from "../images/Alshafi.jpg";
import TCF from "../images/TCF.png";
import Telescope from "../images/Telescope.jpg";
import Yasser from "../images/Yasser.png";
import TimeZone from "../images/TimeZone.jpg";
import MapCanada from "../images/MapCanada.a3d6d1e91126c7771748.jpg";
import Hammer from "../images/Hammer.jpg";
import Lucera from "../images/Lucera.jpg";
import Leen from "../images/lenn.jpg";
import Vibranum from "../images/vibranum.cfe097443564d53e819f.jpg";
import IRIS from "../images/Iris.jpg";
import Rahaf from "../images/Maa.png";
import Agency from "../images/31agency.jpg";
import Concept from "../images/CON.jpg";

const translations = {
  en: {
    clientsCount: "+100 Clients Trust Us",
    pioneers: "Pioneers Who Trust Us",
    pioneersDesc:
      "We’re proud to be the smart home partner of choice for innovators, developers, and pioneers across the region . Each logo represents a collaboration built on trust, forward thinking, and a shared commitment to smarter living",
    clientProjects: "Smarter Homes, Real Stories",
    realImpact:
      "From luxury villas to commercial spaces, explore how Mass Smart Solutions brought intelligence to life — one project at a time.",
    leadershipQuote:
      "The system gives full control over lighting and devices, with easy mobile access for managing the entire center.",
    leadershipName: "Motasim Masalmeh",
    leadershipRole: "CEO telescope",
  },
  ar: {
    clientsCount: "+100 عميل يثق بنا",
    pioneers: "الروّاد الذين يثقون بنا",
    pioneersDesc:
      "نفخر بكوننا الشريك المفضل في حلول المنازل الذكية للروّاد والمطوّرين والمبتكرين في مختلف أنحاء المنطقة. كل شعار هنا يعبّر عن شراكة قائمة على الثقة والرؤية المستقبلية والسعي المشترك نحو أسلوب حياة أكثر ذكاء",
    clientProjects: "منازل أذكى، تجارب حقيقية",
    realImpact:
      "من الفلل الفاخرة إلى المساحات التجارية — اكتشف كيف حوّلت Mass Smart Solutions الرؤية إلى واقع ذكي، مشروعًا تلو الآخر",
    leadershipQuote:
      "يوفّر النظام تحكمًا كاملاً بالإضاءة والأجهزة، مع إمكانية إدارة المركز بالكامل بسهولة عبر الهاتف المحمول",
    leadershipName: "معتصم مسالمة",
    leadershipRole: "الرئيس التنفيذي مركز تيليسكوب",
  },
};

function ClientsAndWork() {
  const [loaded, setLoaded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [clients, setClients] = useState(0);
  const [insta, setInsta] = useState(0);
  const [fb, setFb] = useState(0);

  useEffect(() => {
    const animateValue = (setter, end, duration) => {
      let start = 0;
      const increment = end / (duration / 16);
      const step = () => {
        start += increment;
        if (start < end) {
          setter(Math.floor(start));
          requestAnimationFrame(step);
        } else {
          setter(end);
        }
      };
      step();
    };

    animateValue(setClients, 100, 1200);
    animateValue(setInsta, 33100, 1500);
    animateValue(setFb, 1800, 1700);
  }, [setClients]);
  useEffect(() => {
    const floatAnim = document.createElement("style");
    floatAnim.innerHTML = `
    @keyframes floatUpDown {
      0% { transform: translateY(0); }
      50% { transform: translateY(-10px);}
      100% { transform: translateY(0);}
    }
  `;
    document.head.appendChild(floatAnim);
    return () => document.head.removeChild(floatAnim);
  }, []);

  const { language } = useLanguage();
  const t = translations[language];
  const isAr = language === "ar";

  const clientVideos = [
    { video: "https://www.instagram.com/reel/DPbJAYHAVHu/" },
    { video: "https://www.instagram.com/reel/DRKf4T1jId1/" },
    { video: "https://www.instagram.com/reel/DOJfp5TErca" },
    { video: "https://www.instagram.com/reel/DNjDSw4T2gZ/" },
    { video: "https://www.instagram.com/reel/C5PBQ0Ks_yu/" },
    { video: "https://www.instagram.com/reel/C_gOF1kN7XD/" },
    { video: "https://www.instagram.com/reel/DCCeQT2tHpC/" },
    { video: "https://www.instagram.com/reel/C7EiEQtsyrI/" },
    { video: "https://www.instagram.com/reel/DF-72xjMTu1/" },
    { video: "https://www.instagram.com/reel/C2cyJDusv74/" },
    { video: "https://www.instagram.com/reel/C9Xms9Qtwp3/" },
    { video: "https://www.instagram.com/reel/C4GnKgrsYql/" },
    { video: "https://www.instagram.com/reel/DFam8vFM8Tj/" },
    { video: "https://www.instagram.com/reel/DIhRX11K9_8/" },
    { video: "https://www.instagram.com/reel/DEAosBdN1OZ/" },
    { video: "https://www.instagram.com/reel/C29uT_Zsten/" },
    { video: "https://www.instagram.com/reel/C6EnRVDMYUg/" },
    { video: "https://www.instagram.com/reel/DP9RUg4kuLO/" },
    { video: "https://www.instagram.com/reel/DOyENBsEnM9/" },
    { video: "https://www.instagram.com/reel/DQgq-xCDFPY/" },
  ];

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .partial-border-title {
        display: inline-block;
        position: relative;
        padding: 0.6rem 1.5rem 0.6rem 0.6rem;
        font-weight: 800;
        border-radius: 0 17px 0 0;
        font-size: 2.2rem;
      }
      .partial-border-title::before,
      .partial-border-title::after {
        content: "";
        position: absolute;
        pointer-events: none;
        opacity: 1;
      }
      .partial-border-title::before {
        top: 0;
        right: 0;
        width: 28px;
        height: 5px;
        background: linear-gradient(90deg, #1784e6 0%, #1a4bb7 100%);
      }
      .partial-border-title::after {
        top: 0;
        right: 0;
        width: 5px;
        height: 25px;
        background: linear-gradient(180deg, #1784e6 0%, #1a4bb7 100%);
      }
      @media (max-width: 700px) {
        .partial-border-title {
          font-size: 1.15rem !important;
        }
        .partial-border-title::before { width: 18px; height: 3.5px; }
        .partial-border-title::after { width: 3.5px; height: 18px; }
      }
      .dark .slick-dots li button:before,
      .dark .slick-dots li.slick-active button:before {
        color: #fff !important;
        opacity: 1 !important;
      }

       /* Testimonial cards: light by default */
    .testimonial-card{
      background:#fff;
      color:#222;
      border:1px solid #e0e0e0;
    }
    /* Dark mode override */
    .dark .testimonial-card{
      background:#111;
      color:#fff;
      border:1px solid #fff;
    }

    /* Make quote color inherit the card's text color */
    .testimonial-card blockquote{
      color: inherit;
    }

    /* Keep your existing slick dots dark-mode rules … */
    .dark .slick-dots li button:before,
    .dark .slick-dots li.slick-active button:before {
      color: rgba(255, 255, 255) !important;
      opacity: 1 !important;
    }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    script.onload = () => {
      setTimeout(() => setLoaded(true), 800);
    };
    document.body.appendChild(script);

    const handleScroll = () => setShowButton(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderVideo = (videoUrl) => (
    <div style={styles.instagramEmbed(loaded)}>
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={videoUrl}
        data-instgrm-version="14"
        style={{ border: 0, margin: "0 auto", maxWidth: "100%" }}
      ></blockquote>
    </div>
  );

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    cssEase: "linear",
    pauseOnHover: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section
      style={{
        ...styles.section,
        direction: isAr ? "rtl" : "ltr",
        fontFamily: isAr ? "'Cairo', 'Tajawal', Tahoma" : "Poppins, sans-serif",
      }}
    >
      <section style={styles.clientsSection}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2.2rem",
            marginBottom: "1.3rem",
            flexWrap: "wrap",
            zIndex: 1,
          }}
        >
          {[
            { name: isAr ? "دبي" : "Dubai", color: "#1a4bb7" },
            { name: isAr ? "عمان" : "Amman", color: "#1a4bb7" },
          ].map((city, idx) => (
            <div
              key={city.name}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: "90px",
                margin: "0 0.6rem",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  marginBottom: "10px",
                  animation: "floatUpDown 2s ease-in-out infinite",
                }}
              >
                <FaMapMarkerAlt
                  size={32}
                  color={city.color}
                  style={{
                    filter: "drop-shadow(0 2px 10px #2297e644)",
                  }}
                />
              </span>
              <span
                style={{
                  display: "inline-block",
                  background: `linear-gradient(90deg, #1784e6 0%, #1a4bb7 100%)`,
                  color: "#fff",
                  padding: "0.65rem 1.7rem",
                  borderRadius: "30px",
                  fontWeight: 700,
                  fontSize: isAr ? "1.07rem" : "1.12rem",
                  letterSpacing: "0.6px",
                  boxShadow: "0 2px 16px 0 rgba(23,132,230,0.09)",
                  fontFamily: isAr
                    ? "'Cairo', sans-serif"
                    : "'Poppins', sans-serif",
                  border: "none",
                  position: "relative",
                  transition:
                    "transform 0.23s cubic-bezier(.48,1.7,.36,.83), box-shadow 0.2s",
                  cursor: "default",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform =
                    "translateY(-4px) scale(1.06)";
                  e.currentTarget.style.boxShadow = "0 8px 20px 0 #1784e63b";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "";
                  e.currentTarget.style.boxShadow =
                    "0 2px 16px 0 rgba(23,132,230,0.09)";
                }}
              >
                {city.name}
              </span>
            </div>
          ))}
        </div>

        <h2 className="partial-border-title">
          <span style={styles.gradient}>{t.pioneers}</span>
        </h2>
        <p style={styles.subheading}>{t.pioneersDesc}</p>
        <div style={styles.clientsGrid}>
          {[
            Damac,
            Alshafi,
            TCF,
            Telescope,
            Yasser,
            TimeZone,
            MapCanada,
            Hammer,
            Lucera,
            Leen,
            IRIS,
            Vibranum,
            Rahaf,
            Agency,
            Concept,
            Albeer,
            Alfurjan,
            Hills,
            PlanB,
            Zaaabeel,
            Blind,
            Tokyo,
          ].map((logo, idx) => (
            <div key={idx} style={styles.clientCard}>
              <img
                src={logo}
                alt={`Client ${idx + 1}`}
                style={styles.clientLogo}
              />
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: "3rem 2rem", textAlign: "center" }}>
        <h2 className="partial-border-title">
          <span style={styles.gradient}>
            {isAr
              ? "موضع ثقة أكثر من ١٠٠ عميل في المنطقة"
              : "Trusted by 100+ Clients Across the Region"}
          </span>
        </h2>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "3rem",
            marginTop: "2rem",
          }}
        >
          <div>
            <FaUsers size={48} style={{ color: "#1a4bb7" }} />
            <h3 style={styles.countNumber}>+{clients}</h3>
            <p>{isAr ? "عميل موثوق" : "Clients"}</p>
          </div>
          <div>
            <FaInstagram size={48} style={{ color: "#C13584" }} />
            <h3 style={{ ...styles.countNumber, color: "#C13584" }}>
              {insta.toLocaleString()}
            </h3>
            <p>Instagram {isAr ? "متابع" : "Followers"}</p>
          </div>
          <div>
            <FaFacebookF size={48} style={{ color: "#1877f2" }} />
            <h3 style={{ ...styles.countNumber, color: "#1877f2" }}>
              {fb.toLocaleString()}
            </h3>
            <p>Facebook {isAr ? "متابع" : "Followers"}</p>
          </div>
        </div>
      </section>

      <section
        style={{
          padding: "3rem 2rem",
          textAlign: "center",
          marginTop: "3rem",
          borderRadius: "1rem",
        }}
      >
        <h2
          style={{
            fontSize: isAr ? "2rem" : "2.2rem",
            fontWeight: "800",
            marginBottom: "1.5rem",
            fontFamily: isAr ? "'Cairo', sans-serif" : "'Poppins', sans-serif",
          }}
        >
          {isAr
            ? "هل ترغب بأن تكون ضمن هذه القائمة؟"
            : "Want to join this list?"}
        </h2>
        <p
          style={{
            fontSize: "1.15rem",

            marginBottom: "2rem",
          }}
        >
          {isAr
            ? "دعنا نُحوّل مساحتك إلى مساحة أكثر ذكاءً"
            : "Let’s make your space smarter."}
        </p>
        <a
          href="/contact"
          style={{
            display: "inline-block",
            background: "linear-gradient(to right, #1784e6, #1a4bb7)",
            color: "#fff",
            padding: "0.8rem 2rem",
            borderRadius: "30px",
            fontSize: "1rem",
            fontWeight: "600",
            textDecoration: "none",
            transition: "background 0.3s ease",
          }}
          onMouseOver={(e) => (e.target.style.opacity = 0.9)}
          onMouseOut={(e) => (e.target.style.opacity = 1)}
        >
          {isAr ? "تواصل معنا →" : "Get in touch →"}
        </a>
      </section>

      <div style={{ textAlign: "center" }}>
        <h2 className="partial-border-title">
          <span style={styles.gradient}>{t.clientProjects}</span>
        </h2>
      </div>
      <p style={styles.subheading}>{t.realImpact}</p>
      <section style={{ padding: "2rem 0" }}>
        <Slider {...sliderSettings} style={styles.slider}>
          {clientVideos.map((client, index) => (
            <div key={index} style={styles.slide}>
              <div style={styles.projectCard}>
                <div style={styles.mediaRow}>
                  <div style={styles.videoBox}>{renderVideo(client.video)}</div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>
      {showButton && (
        <button onClick={scrollToTop} style={styles.backToTopBtn}>
          <FaChevronUp />
        </button>
      )}

      <div
        style={{ textAlign: "center", marginTop: "4rem", marginBottom: "2rem" }}
      >
        <h2 className="partial-border-title">
          <span style={styles.gradient}>
            {isAr ? "شهادات عملائنا" : "Client Testimonials"}
          </span>
        </h2>
      </div>

      <section
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "2rem",
          padding: "2rem 1rem",
        }}
      >
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={Telescope}
              alt={t.leadershipName}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {t.leadershipName}
              </strong>
              <br />
              <span style={{ color: "#2297e6", fontSize: "0.95rem" }}>
                {t.leadershipRole}
              </span>
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            “{t.leadershipQuote}”
          </blockquote>
        </div>

        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={lorans}
              alt={isAr ? "لين السعدي" : "Leen Al Saadi"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "لورانس المنسي" : "Lorans Almansi"}
              </strong>
              <br />
              <span style={{ color: "#2297e6", fontSize: "0.95rem" }}>
                {isAr ? "  الرئيس التنفيذي  31Agency   " : "CEO 31Agency"}
              </span>
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "وصلني تنبيه بوجود شخص عند باب المنزل،فلجأت مباشرة إلى أليكسا — حيث فتحت الستائر والأضواء، وأعادت الروبوت إلى الشاحن، وشغّلت المكيّف وماكينة القهوة.تم كل ذلك بسلاسة ومن دون أي تدخل يدوي.إن كنت تبحث عن هذا المستوى من الذكاء والراحة، فإن ماس للحلول الذكية هي الخيار الأمثل"
              : "“I received a notification that someone was at my front door .I turned to Alexa — the curtains opened, the lights came on, the robot returned to its charger, and both the AC and coffee machine started up.Everything happened smoothly, without me lifting a finger.If you're looking for this level of intelligence and comfort, Mass Smart Solutions is the way to go”"}
          </blockquote>
        </div>
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={Rami}
              alt={isAr ? "لين السعدي" : "Leen Al Saadi"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "رامي " : "Rami "}
              </strong>
              <br />
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "ركّبوا النظام خلال ٤٨ ساعة بدون تخريب. السعر ممتاز، والأمان عالي. بتحكم بالبيت بالكامل من جوالي، حتى وأنا خارج المنزل. تجربة رائعة مع ماس "
              : "“Installation took just 48 hours with no damage .Great price, high security, and full control from my phone, even when I’m away.Amazing experience with Mass.”"}
          </blockquote>
        </div>
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={Sabbag}
              alt={isAr ? "لين السعدي" : "Leen Al Saadi"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "محمد صباغ" : "Mohammad Sabbagh"}
              </strong>
              <br />
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "كل اشي في البيت صار بكلمة.أليكسا، أنا وصلت… الإضاءة والمكيف بشتغلوا، الجو بتغيّر.أليكسا، وقت الأفلام.أليكسا، وقت الألعاب.أليكسا، تصبحي على خير — وكل شي بنطفي لحاله.بيت ذكي فعلاً… مريح، ومتجاوب مع مزاجي"
              : "“Everything at home now responds to just a word . ‘Alexa, I’m home’ — the lights and AC come on, and the mood shifts. ‘Alexa, movie time .’‘Alexa, gaming mode .’‘Alexa, goodnight’ — and everything shuts down automatically . Truly a smart home — comfortable and always in sync with my mood”"}
          </blockquote>
        </div>
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={leen}
              alt={isAr ? "لين السعدي" : "Leen Al Saadi"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "لين عطعوط" : "Leen Atout"}
              </strong>
              <br />
              <span style={{ color: "#2297e6", fontSize: "0.95rem" }}>
                {isAr ? " مهندسة ديكور   " : "Interior Designer"}
              </span>
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "كنت من الناس اللي ما جربوا التكنولوجيا الذكية… واليوم ما بقدر أتخيل حياتي بدونها.التصميم الداخلي مهم، والنظام الذكي من ماس للحلول الذكية هو اللي بكمله.ما اضطرّينا نغيّر المخططات، وانبهرت بالسرعة والدقة — وكل هاد بدون تمديد أو تحفير."
              : "I used to live without smart tech — now I can’t imagine life without it . Interior design is important, but the smart system from Mass Smart Solutions completes it . No layout changes were needed, and I was amazed by the speed, precision, and how it all works without extra wiring or drilling."}
          </blockquote>
        </div>
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={hamza}
              alt={isAr ? "لينا وحمزه" : "Leena Labady & Hamza Samara"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "لينا وحمزه" : "Leena Labady & Hamza Samara"}
              </strong>
              <br />
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "من أول ما جبنا أليكسا، صارت جزء من يومنا. كل جهاز بنركبه بينشبك بسهولة، والتحكم صار من التطبيق ومن أي مكان.مرة طفينـا مضخة وإحنا برا البيت بثواني، وشغّلنا المكيف قبل ما نوصل.حتى الزوّار بنشوفهم بالكاميرا وبنفتح الباب من بعيد.الراحة والتحكم الكامل... صارت بلمسة"
              : "“Ever since we brought Alexa to home, it became part of our daily life.Every new device connects easily, and we can control everything from the app — wherever we are.Once, we turned off a water pump remotely in seconds, and we always switch on the AC before arriving.Even when guests arrive, we see them through the camera and unlock the door from afar.Comfort and full control — all with a tap.”"}
          </blockquote>
        </div>
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={MD}
              alt={isAr ? "لين السعدي" : "Leen Al Saadi"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "محمد الضميري " : "Mohammad Al Dumairy "}
              </strong>
              <br />
              <span style={{ color: "#2297e6", fontSize: "0.95rem" }}>
                {isAr ? "" : " Damac"}
              </span>
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "بصفتنا شركة تطوير عقاري، فكرنا في إضافة نظام ذكي إلى الشقق.في البداية، ظننت أن الأمر مجرد رفاهية، لكن بعد التعامل مع شركة ماس تغيّرت وجهة نظري تمامًا.سرعة في الاستجابة، دقة في التنفيذ، وأي ملاحظة كانت تُعالَج في نفس اليوم أو في اليوم التالي.ومع الاستخدام، أصبح النظام جزءًا أساسيًا من الحياة اليومية، لا رفاهية.تفاصيل بسيطة كفتح الستائر أو تحضير القهوة أصبحت من الضروريات.تجربة ممتازة، شكرًا ماس"
              : "As a real estate developer, I initially saw smart home tech as a luxury . But working with Mass changed that completely . Fast responses, precise execution, and any issue was handled within a day.Once I started using the system, it became essential . Everyday things — like opening curtains or making coffee — now feel like a must.Great experience . Thank you, Mass!"}
          </blockquote>
        </div>
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={Omar}
              alt={isAr ? "لين السعدي" : "Leen Al Saadi"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "عمر ابو الرب " : "Omar Aburob"}
              </strong>
              <br />
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "كنت قاعد مع صحابي، حكيت لأليكسا تفتح البرادي — وفتحت فورًا.بعدين وأنا بكافيه، فتحت الكاميرا وشفت إنو كل شي تمام بالبيت.بلّشت أتابع استهلاك الكهربا وأوفّر على الفواتير — وأنا أصلاً مش بالبيت.إذا بدك هيك مستوى من الراحة والتحكم… خليك ماس"
              : "I was sitting with friends when I asked Alexa to open the shutters — and they opened instantly.Later, while relaxing at a café, I checked the home cameras and made sure everything was secure . I’ve started tracking my electricity usage and saving on bills — all while away from home.If you're looking for this level of control… choose Mass"}
          </blockquote>
        </div>
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={couple}
              alt={isAr ? "لين السعدي" : "Leen Al Saadi"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "زوجان من عملاء ماس" : "A Happy Couple"}
              </strong>
              <br />
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "كنت أبحث عن نظام منزلي ذكي ونظيف وسمعت الكثير عن شركة ماس للحلول الذكية، لذا فاجأت زوجتي. ما أثار إعجابنا أكثر هو دعمهم السريع، حيث يتم حل أي مشكلة على الفور. يمكنني فتح الباب أثناء وجودي في الخارج، والتحكم في مضخة المياه، كما تدير زوجتي مكيف الهواء وماكينة القهوة بسهولة. شكرًا لك يا Mass على هذه التجربة السلسة والذكية"
              : "“I was looking for a clean smart home setup and heard a lot about Mass — so I made it a surprise for my wife.What impressed us most was their quick support — any issue gets resolved instantly . I can unlock the door while abroad, control the water pump, and she manages the AC and coffee machine with ease . Thank you, Mass, for a smooth and smart experience."}
          </blockquote>
        </div>
        <div
          className="testimonial-card"
          style={{
            maxWidth: 500,
            borderRadius: "1rem",
            padding: "1.5rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            border: "1px solid",
            textAlign: isAr ? "right" : "left",
            direction: isAr ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <img
              src={om}
              alt={isAr ? "لين السعدي" : "Leen Al Saadi"}
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #2297e6",
                marginRight: isAr ? 0 : "1rem",
                marginLeft: isAr ? "1rem" : 0,
              }}
            />
            <div>
              <strong style={{ color: "#1a4bb7", fontSize: "1rem" }}>
                {isAr ? "عمر حميدات" : "Omar Hmaidat"}
              </strong>
              <br />
              <span style={{ color: "#2297e6", fontSize: "0.95rem" }}>
                {isAr ? "الرئيس التنفيذي DMS" : " CEO DMS"}
              </span>
            </div>
          </div>
          <blockquote
            style={{ fontStyle: "italic", fontSize: "1.00rem", margin: 0 }}
          >
            {isAr
              ? "لم يعد هناك وقت… فالحياة أصبحت سريعة، أسرع بكثير مما نتخيل.ولهذا أنصح الجميع بالبحث عن حلول تُسهّل وتسـرّع إيقاع الحياة اليومية، لأن التطور الحاصل من حولنا غير مسبوق.وسط الضغوطات اليومية، شعرت أنني بحاجة إلى لحظة أدلّع فيها نفسي — فقررت أن أضيف لمسة من الرفاهية إلى حياتي… لكنها ليست أي رفاهية.النجاح يتطلب تعب… والعطاء يحتاج إلى راحة.لذلك اخترت الراحة الذكية من ماس للحلول الذكية — راحة مختلفة، سلسة، وعلى مقاسي تمامًا"
              : "“There’s no more time — life moves faster than we ever imagined . That’s why I believe in finding solutions that simplify and accelerate daily life, because the pace of change is unreal.Withall the pressure I face, I needed to treat myself — so I added a touch of luxury to my life… but not just any luxury . Success takes effort… and giving takes energy . That’s why I chose smart comfort from Mass Smart Solutions — something seamless, elevated, and perfectly tailored to me."}
          </blockquote>
        </div>
      </section>
    </section>
  );
}

const styles = {
  section: {
    padding: "1rem",
  },
  gradient: {
    background: "linear-gradient(to right, #1784e6 0%, #1a4bb7)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  subheading: {
    textAlign: "center",
    fontSize: "1rem",
    marginBottom: "3rem",
    padding: "0 1rem",
  },
  slider: {
    maxWidth: "1100px",
    margin: "0 auto",
  },
  slide: {
    padding: "1rem",
  },
  projectCard: {
    padding: "1.2rem",
    borderRadius: "12px",
  },
  mediaRow: {
    display: "flex",
    justifyContent: "center",
  },
  videoBox: {
    width: "100%",
    maxWidth: "360px",
    borderRadius: "12px",
    overflow: "hidden",
  },
  instagramEmbed: (loaded) => ({
    width: "100%",
    minHeight: "300px",
    display: "flex",
    justifyContent: "center",
    opacity: loaded ? 1 : 0,
    transform: loaded ? "translateY(0)" : "translateY(20px)",
    transition: "opacity 1s ease, transform 0.8s ease",
  }),
  clientsSection: {
    textAlign: "center",
    padding: "4rem 1rem 3rem",
  },
  clientsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
    gap: "1.5rem",
    maxWidth: "800px",
    margin: "0 auto",
    alignItems: "center",
  },
  clientCard: {
    padding: "1rem",
    display: "flex",
    justifyContent: "center",
    height: "140px",
  },
  clientLogo: {
    maxHeight: "100%",
    maxWidth: "100%",
    objectFit: "contain",
    transform: "scale(1.15)",
    transition: "transform 0.3s ease",
  },
  countNumber: {
    fontSize: "2.6rem",
    fontWeight: "800",
    animation: "pulseGlow 2s infinite ease-in-out",
  },
  backToTopBtn: {
    position: "fixed",
    bottom: "40px",
    left: "25px",
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    backgroundColor: "rgba(57, 47, 47, 0.3)",
    color: "#fff",
    border: "none",
    fontSize: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    zIndex: 999,
  },
};

export default ClientsAndWork;
